"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFlowExport = exports.universalExport = exports.mapIssueToSavedIssue = exports.mapDedupedResultsToUniversalIssue = exports.mapDedupedPageStatesToUniversalIssue = exports.mapAxeResultsToIssues = exports.mapAxeExtensionIssueToUniversalIssue = exports.manifestUtils = exports.jUnitXmlExport = exports.jsonUniversal = exports.getIssuesWithUniversalMatches = exports.getIgtName = exports.getFriendlyFilename = exports.filterUserFlowResults = exports.filterUniversalIssues = exports.filterIssuesByConfig = exports.filterIssues = exports.exportIssues = exports.buildPageStateKey = void 0;
const export_1 = require("./export");
Object.defineProperty(exports, "exportIssues", { enumerable: true, get: function () { return export_1.exportIssues; } });
Object.defineProperty(exports, "jUnitXmlExport", { enumerable: true, get: function () { return export_1.jUnitXmlExport; } });
Object.defineProperty(exports, "universalExport", { enumerable: true, get: function () { return export_1.universalExport; } });
Object.defineProperty(exports, "userFlowExport", { enumerable: true, get: function () { return export_1.userFlowExport; } });
const json_universal_1 = __importDefault(require("./formats/json-universal"));
exports.jsonUniversal = json_universal_1.default;
const build_page_state_key_1 = require("./utils/build-page-state-key");
Object.defineProperty(exports, "buildPageStateKey", { enumerable: true, get: function () { return build_page_state_key_1.buildPageStateKey; } });
const filter_extension_issues_1 = require("./utils/filter-extension-issues");
Object.defineProperty(exports, "filterIssuesByConfig", { enumerable: true, get: function () { return filter_extension_issues_1.filterIssuesByConfig; } });
const filter_universal_issues_1 = __importDefault(require("./utils/filter-universal-issues"));
exports.filterUniversalIssues = filter_universal_issues_1.default;
const filter_user_flow_results_1 = __importDefault(require("./utils/filter-user-flow-results"));
exports.filterUserFlowResults = filter_user_flow_results_1.default;
const friendly_filename_1 = require("./utils/friendly-filename");
Object.defineProperty(exports, "getFriendlyFilename", { enumerable: true, get: function () { return friendly_filename_1.getFriendlyFilename; } });
const getIssuesWithUniversalMatches_1 = require("./utils/getIssuesWithUniversalMatches");
Object.defineProperty(exports, "getIssuesWithUniversalMatches", { enumerable: true, get: function () { return getIssuesWithUniversalMatches_1.getIssuesWithUniversalMatches; } });
const igt_name_map_1 = require("./utils/igt-name-map");
Object.defineProperty(exports, "getIgtName", { enumerable: true, get: function () { return igt_name_map_1.getIgtName; } });
const issue_filter_1 = __importDefault(require("./utils/issue-filter"));
Object.defineProperty(exports, "filterIssues", { enumerable: true, get: function () { return issue_filter_1.default; } });
const issue_mapper_1 = require("./utils/issue-mapper");
Object.defineProperty(exports, "mapAxeExtensionIssueToUniversalIssue", { enumerable: true, get: function () { return issue_mapper_1.mapAxeExtensionIssueToUniversalIssue; } });
Object.defineProperty(exports, "mapAxeResultsToIssues", { enumerable: true, get: function () { return issue_mapper_1.mapAxeResultsToIssues; } });
Object.defineProperty(exports, "mapDedupedPageStatesToUniversalIssue", { enumerable: true, get: function () { return issue_mapper_1.mapDedupedPageStatesToUniversalIssue; } });
Object.defineProperty(exports, "mapDedupedResultsToUniversalIssue", { enumerable: true, get: function () { return issue_mapper_1.mapDedupedResultsToUniversalIssue; } });
Object.defineProperty(exports, "mapIssueToSavedIssue", { enumerable: true, get: function () { return issue_mapper_1.mapIssueToSavedIssue; } });
const manifestUtils = __importStar(require("./utils/manifest-utils"));
exports.manifestUtils = manifestUtils;
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map